import { Reveal, MaskedText } from "@/components/motion/Reveal";
import { OpenableImage } from "@/components/MediaViewer";
import { GALLERIES } from "@/data/media";
import { LOCATION } from "@/data/content";
import { ArrowDownToLine } from "lucide-react";

function GalleryGroup({ group }) {
  return (
    <section data-testid={`gallery-group-${group.id}`} className="px-6 py-20 md:px-12 md:py-28">
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-12 flex flex-col gap-4 md:mb-16 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <p className="overline mb-4 text-muted">({group.id.replace("-", " ")})</p>
            <h2 className="font-display text-2xl font-extralight tracking-tight text-ink md:text-4xl">
              {group.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-xs font-body text-sm leading-relaxed text-stone">{group.note}</p>
          </Reveal>
        </div>

        <div className="gap-4 md:gap-8 [column-count:1] sm:[column-count:2] lg:[column-count:3]">
          {group.images.map((image, i) => (
            <Reveal key={image.src} delay={(i % 3) * 0.06} className="mb-4 break-inside-avoid md:mb-8">
              <OpenableImage
                src={image.src}
                alt={image.alt}
                label=""
                className="!bg-paper2"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Gallery() {
  return (
    <>
      <section data-testid="gallery-hero" className="px-6 pb-4 pt-36 md:px-12 md:pt-44">
        <div className="mx-auto max-w-[1400px]">
          <Reveal>
            <p className="overline mb-8 text-muted">(Gallery)</p>
          </Reveal>
          <MaskedText
            lines={["Selected", "Work"]}
            delay={0.1}
            className="font-display text-[11vw] font-extralight leading-[0.92] tracking-tight text-ink lg:text-[7vw]"
          />
          <Reveal delay={0.3}>
            <p className="mt-10 max-w-md font-body text-sm leading-relaxed text-stone">
              An ever-growing archive of commercial and campaign stills — image, product
              and still life, made in {LOCATION}. Tap any frame to pop it open in its
              own window.
            </p>
          </Reveal>
          <Reveal delay={0.42}>
            <a
              href="/phaedra-paulson-stylist-portfolio.pdf"
              download
              data-testid="download-portfolio-pdf"
              className="group mt-10 inline-flex items-center gap-3 rounded-full border border-ink px-6 py-3 font-body text-sm text-ink transition-colors duration-300 hover:bg-ink hover:text-paper"
            >
              <span>Download portfolio (PDF)</span>
              <ArrowDownToLine className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </a>
          </Reveal>
        </div>
      </section>

      {GALLERIES.map((group, i) => (
        <div key={group.id} className={i > 0 ? "border-t border-hairline" : ""}>
          <GalleryGroup group={group} />
        </div>
      ))}
    </>
  );
}
